import Rate, { validatorGenerate as rateValidatorGenerate } from './Rate';
import MultipleSelect from './MultipleSelect';
import Select from './Select';
import Description from './Description';

export const itemMap = {
    five_star_scoring: Rate,
    select: Select,
    multi_select: MultipleSelect,
    description: Description,
    questionnaire_description: null
};

const defaultValidatorGenerate = () => {
    return {};
};
export const validatorGenerateMap = {
    five_star_scoring: defaultValidatorGenerate,
    select: defaultValidatorGenerate,
    multi_select: defaultValidatorGenerate,
    description: defaultValidatorGenerate,
    questionnaire_description: defaultValidatorGenerate
};
